export default "__VITE_ASSET__Un3C7HsK__"